<script setup>
import AboutSection from '@/views/front-pages/landing-page/AboutSection.vue'
import CtaBanner from '@/views/front-pages/landing-page/CtaBanner.vue'
import FaqSection from '@/views/front-pages/landing-page/FaqSection.vue'
import FeaturesSection from '@/views/front-pages/landing-page/FeaturesSection.vue'
import HeroSection from '@/views/front-pages/landing-page/HeroSection.vue'
import HowItWorks from '@/views/front-pages/landing-page/HowItWorks.vue'
import PricingSection from '@/views/front-pages/landing-page/PricingSection.vue'
import TestimonialsSection from '@/views/front-pages/landing-page/TestimonialsSection.vue'
import LandingFooter from '@/views/front-pages/LandingFooter.vue'
import LandingNavbar from '@/views/front-pages/LandingNavbar.vue'
import { useConfigStore } from '@core/stores/config'

definePage({ meta: { layout: 'blank', public: true } })

const store = useConfigStore()
store.skin = 'default'

// Redirect ke dashboard jika sudah login
const router = useRouter()
const userData = useCookie('userData')
const accessToken = useCookie('accessToken')

onMounted(() => {
  if (userData.value && accessToken.value) {
    router.push({ name: 'dashboards-analytics' })
  }
})
</script>

<template>
  <div class="landing-page-wrapper">
    <LandingNavbar />

    <main>
      <HeroSection />
      <FeaturesSection />
      <HowItWorks />
      <AboutSection />
      <TestimonialsSection />
      <PricingSection />
      <FaqSection />
      <CtaBanner />
    </main>

    <LandingFooter />
  </div>
</template>

<style lang="scss">
.landing-page-wrapper {
  overflow-x: hidden;

  section {
    scroll-margin-top: 80px; // offset fixed navbar
  }
}

@media (max-width: 960px) and (min-width: 600px) {
  .landing-page-wrapper {
    .v-container { padding-inline: 2rem !important; }
  }
}
</style>
